/**
 * Check if value is nullish (`void`, `null` or `undefined`).
 * @param {*} value - Value that will be checked.
 * @returns {Boolean}
 */
function isNullish(value) {
    return value == null;
}

export { isNullish as default };
//# sourceMappingURL=main.mjs.map
